export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11376.be117b8f.jpg";